module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"badge":"AIサイズ提案"}}')
  delete Component.options._Ctor
}
